import { PreviewType } from 'js/file_viewer/core/types/preview_type';
import { PHOTO_EXTS, PRESENTATION_EXTS, MSOFFICE_EXCEL_EXTS, WORDPROC_EXTS, PDF_EXTS, DOCUMENT_EXTS, CLOUD_DOC_EXTS, TRANSCODE_VIDEO_EXTS, HTMLIFIED_PREVIEW_EXTS, LINK_FILE_EXTS, AUDIO_EXTS, LOGGING_ALLOWED_EXTS, LOGGING_UNALLOWED_EXT_PLACEHOLDER, ARCHIVE_EXTS, EPUB_EXTS, IWORK_EXTS, NON_GENERATED_HTML_EXTS, THUMBNAIL_IMAGE_EXTS, GOOGLE_CLOUD_DOC_EXTS, } from 'js/file_viewer/file_extension/extension_constants';
/**
 * Uses unified constants generated from dropbox/server/extension_constants.py
 */
/**
 * Adobe extensions that preview as images
 */
const ADOBECS_IMAGE_EXTS = ['.xd'];
/* until tslib dependency issues are ironed out, phrase this using concat() rather than ...spread syntax:
 * You will know that tslib is in a better place if the tslib dependency shown in *Spectrum*'s package.json
 * file reads something like this:
 *   "tslib": "^1.10.0",
 *
 * Right now it specifies an exact version of the library, and one that's lower than than number (1.9.3).
 */
const IMAGE_EXTS = PHOTO_EXTS.concat(ADOBECS_IMAGE_EXTS);
/**
 * Extensions that are considered doc
 */
const DOC_EXTS = PDF_EXTS.concat(DOCUMENT_EXTS, PRESENTATION_EXTS, WORDPROC_EXTS, EPUB_EXTS);
const LOGGING_ALLOWED_EXTS_SET = new Set(LOGGING_ALLOWED_EXTS);
/**
 * Resolves preview type from extension
 * IMPORTANT: This is not really accurate due to hardcoded
 * extension whitelists so it is preferrable to use
 * `resolvePreviewType` from `core/utils` instead.
 * Use cases:
 * 1. Primarily used to constant-time gating before we make the call
 * to Previews Data API
 * @param fileExtension file extension
 */
export function resolvePreviewTypeFromExtension(fileExtension) {
    fileExtension = fileExtension.toLowerCase();
    if (MSOFFICE_EXCEL_EXTS.includes(fileExtension)) {
        return PreviewType.Excel;
    }
    if (DOC_EXTS.includes(fileExtension)) {
        return PreviewType.SsrDoc;
    }
    if (IMAGE_EXTS.includes(fileExtension)) {
        return PreviewType.Image;
    }
    if (TRANSCODE_VIDEO_EXTS.includes(fileExtension)) {
        return PreviewType.Video;
    }
    if (AUDIO_EXTS.includes(fileExtension)) {
        return PreviewType.Audio;
    }
    if (LINK_FILE_EXTS.includes(fileExtension)) {
        return PreviewType.Linkfile;
    }
    if (HTMLIFIED_PREVIEW_EXTS.includes(fileExtension)) {
        return PreviewType.Text;
    }
    if (NON_GENERATED_HTML_EXTS.includes(fileExtension)) {
        return PreviewType.RawHTML;
    }
    if (GOOGLE_CLOUD_DOC_EXTS.includes(fileExtension)) {
        // Google DSS are now unsupported
        return PreviewType.Error;
    }
    if (CLOUD_DOC_EXTS.includes(fileExtension)) {
        return PreviewType.CloudDoc;
    }
    if (ARCHIVE_EXTS.includes(fileExtension)) {
        return PreviewType.Archive;
    }
    if (IWORK_EXTS.includes(fileExtension)) {
        // We don't support full IWORK previews so we just show an image of the
        // file contents
        return PreviewType.Image;
    }
    if (THUMBNAIL_IMAGE_EXTS.includes(fileExtension)) {
        // If a file type doesn't have a generated preview but can be thumbnailed
        // Riviera returns an image preview
        return PreviewType.Image;
    }
    return PreviewType.Other;
}
function brandWhitelistedFileExtension(originalFileExt) {
    return originalFileExt;
}
export function getWhitelistedFileExtension(fileExtension) {
    return LOGGING_ALLOWED_EXTS_SET.has(fileExtension)
        ? brandWhitelistedFileExtension(fileExtension)
        : brandWhitelistedFileExtension(LOGGING_UNALLOWED_EXT_PLACEHOLDER);
}
//# sourceMappingURL=extension_constants.preenvesnextjs.map
